import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import jwt from '../plugins/jwt';
import instance from '../plugins/axios';

export default createStore({
  state: {
    locale: 'ko',
    domainInfo: {
      idm_is_register: 1,
      idm_is_sms_auth: 1,
      idm_locale: 'ko',
      idm_status: 2,
      idm_use_casino: 0,
      idm_use_slot: 0,
      idm_use_sport: 0,
    },
    count: 0,
    token: {
      accessToken: jwt.getToken(),
    },
    isAuthenticated: !!jwt.getToken(),
    memberData: {},
    matchCarousel: [],
    upCommingPrematch: [],
    inplayMatchesMain: [],
    prematchList: [],
    inplayMatchList: [],
    matchResultList: [],
    extraPrematchBets: [],
    extraInplayBets: [],
    siteConfig: {},
    balance: {
      wallet: 0,
      balance: 0,
      comp: 0,
    },
    limit: {
      cash: 0,
      loss: null,
    },
    info: {},
    communityCategories: [],
    sportsBetSlip: {
      amount: 0,
      totalOdds: 0,
      slip: [],
    },
    miniBetSlip: {
      amount: 0,
      odds: 0,
      betType: '',
      betTypeText: '',
    },
    miniGameInfo: {
      round: '',
      remainTime: '00:00',
      startTime: '',
    },
    sportsCombineArr: [],
  },
  getters: {
    getAccessToken: function (state) {
      return state.token.accessToken;
    },
    isAuthenticated: function (state) {
      return state.isAuthenticated;
    },
    getMemberData: state => {
      return state.memberData;
    },
    getBalance: state => {
      return state.balance;
    },
    getCommunityCategories: state => {
      return state.communityCategories;
    },
  },
  mutations: {
    logout: function (state, payload = {}) {
      state.token.accessToken = '';
      state.isAuthenticated = false;
      jwt.destroyToken();
    },
    login: function (state, payload = {}) {
      state.token.accessToken = payload.accessToken;
      state.isAuthenticated = true;
      state.memberData = payload.memberData;
      jwt.saveToken(payload.accessToken);
    },
    selectBet: function (state, payload = {}) {
      let findSlipArr = state.sportsBetSlip.slip;

      // 보너스 배당일 경우
      if (payload.match.ism_key === '보너스') {
        // 폴더 수 체크
        if (payload.odds.bonusInfo.isbf_folder > state.sportsBetSlip.slip.length) {
          if (state.locale === 'ko') return alert(`${payload.odds.bonusInfo.isbf_folder}폴더 이상 조합해주세요.`);
          if (state.locale === 'en') return alert(`Please combine more than ${payload.odds.bonusInfo.isbf_folder} folder`);
          if (state.locale === 'cn') return alert(`请合并${payload.odds.bonusInfo.isbf_folder} 个以上的文件夹。`);
          if (state.locale === 'vn') return alert(`Vui lòng kết hợp nhiều hơn ${payload.odds.bonusInfo.isbf_folder} thư mục.`);
        }

        // 최소 배당 체크
        for (const x of state.sportsBetSlip.slip) {
          if (x.match.ism_key === '보너스') continue;

          let odds;
          if (x.betType === 0) {
            odds = x.odds.iso_away_odds;
          } else if (x.betType === 1) {
            odds = x.odds.iso_home_odds;
          } else if (x.betType === 2) {
            odds = x.odds.iso_draw_odds;
          }

          if (odds < payload.odds.bonusInfo.isbf_min_odds) {
            return alert(payload.odds.bonusInfo.isbf_error_message);
          }
        }

        // 보너스가 이미 체크된 경우
        if (state.sportsBetSlip.slip.find(x => x.match.ism_key === '보너스' && x.odds.iso_key !== payload.odds.iso_key)) {
          state.sportsBetSlip.slip = state.sportsBetSlip.slip.filter(x => x.match.ism_key !== '보너스' && x.odds.iso_key !== payload.odds.iso_key);
        }
      }

      // 보너스 배당이 체크돼있는 경우 최소 배당 체크
      if (state.sportsBetSlip.slip.find(x => x.match.ism_key === '보너스') && payload.match.ism_key !== '보너스') {
        let odds;
        if (payload.betType === 0) {
          odds = payload.odds.iso_away_odds;
        } else if (payload.betType === 1) {
          odds = payload.odds.iso_home_odds;
        } else if (payload.betType === 2) {
          odds = payload.odds.iso_draw_odds;
        }

        if (odds < state.sportsBetSlip.slip.find(x => x.match.ism_key === '보너스').odds.bonusInfo.isbf_min_odds) {
          return alert(state.sportsBetSlip.slip.find(x => x.match.ism_key === '보너스').odds.bonusInfo.isbf_error_message);
        }
      }

      // 조합 체크
      for (const combine of state.sportsCombineArr) {
        if (combine.iscb_sports_name !== '전체') {
          if (combine.iscb_sports_name !== payload.match.ism_sports_name) continue;

          findSlipArr = state.sportsBetSlip.slip.filter(slip => slip.match.ism_sports_name === payload.match.ism_sports_name);
        } else {
          if (combine.iscb_game_type !== payload.gameType) continue;
        }

        const combineArr = [];

        for (let i = 1; i < 5; i++) {
          if (combine[`iscb_market_type_${i}`] !== null) {
            combineArr.push({
              marketType: combine[`iscb_market_type_${i}`],
              betType: combine[`iscb_bet_type_${i}`] === '전체' ? combine[`iscb_bet_type_${i}`] : parseInt(combine[`iscb_bet_type_${i}`]),
              scopeType: combine[`iscb_scope_type_${i}`],
            });
          }
        }

        if (combine.iscb_match_type === '동일경기') {
          findSlipArr = findSlipArr.filter(slip => slip.match.ism_key === payload.match.ism_key);
        }

        if (combine.iscb_league_type === '동일리그') {
          findSlipArr = findSlipArr.filter(slip => slip.match.ism_league_id === payload.match.ism_league_id);
        }

        let isVaild = true;

        const checkPayloadCombine = (i, slipIndex) => {
          combineArr.forEach((c2, index2) => {
            if (i !== index2) {
              if (
                (c2.marketType === '전체' || c2.marketType === payload.odds.info_sports_market.ismk_market_type) &&
                findSlipArr[slipIndex].odds.iso_key !== payload.odds.iso_key
              ) {
                if (c2.betType === '전체' || c2.betType === payload.betType) {
                  if (c2.scopeType === '전체' || c2.scopeType === payload.odds.info_sports_market.ismk_market_scope) {
                    isVaild = false;
                  }
                }
              }
            }
          });
        };

        combineArr.forEach((c, index) => {
          findSlipArr.forEach((slip, slipIndex) => {
            if (c.marketType === '전체' || c.marketType === slip.odds.info_sports_market.ismk_market_type) {
              if (c.betType === '전체' || c.betType === slip.betType) {
                if (c.scopeType === '전체' || c.scopeType === slip.odds.info_sports_market.ismk_market_scope) {
                  checkPayloadCombine(index, slipIndex);
                }
              }
            }
          });
        });

        if (!isVaild) {
          if (state.locale === 'ko') return alert(combine.iscb_error_message);
          if (state.locale === 'en') return alert('Combinations of the same match are not allowed');
          if (state.locale === 'cn') return alert('不允许相同匹配的组合');
          if (state.locale === 'vn') return alert('Kết hợp của cùng một trận đấu không được phép');
        }
      }

      if (state.sportsBetSlip.slip.find(x => x.odds.iso_key === payload.odds.iso_key && x.betType === payload.betType)) {
        state.sportsBetSlip.slip = state.sportsBetSlip.slip.filter(x => x.odds.iso_key !== payload.odds.iso_key);

        // 보너스 폴더수 체크
        if (state.sportsBetSlip.slip.find(x => x.match.ism_key === '보너스')) {
          if (
            state.sportsBetSlip.slip.filter(x => x.match.ism_key !== '보너스').length < state.sportsBetSlip.slip.find(x => x.match.ism_key === '보너스').odds.bonusInfo.isbf_folder
          ) {
            state.sportsBetSlip.slip = state.sportsBetSlip.slip.filter(x => x.match.ism_key !== '보너스');
          }
        }
      } else if (state.sportsBetSlip.slip.find(x => x.odds.iso_key === payload.odds.iso_key && x.betType !== payload.betType)) {
        state.sportsBetSlip.slip = state.sportsBetSlip.slip.filter(x => x.odds.iso_key !== payload.odds.iso_key);
        state.sportsBetSlip.slip.push(payload);
      } else {
        state.sportsBetSlip.slip.push(payload);
      }
    },
    deleteBet: function (state, payload = {}) {
      state.sportsBetSlip.slip = state.sportsBetSlip.slip.filter(x => x.odds.iso_key !== payload.odds.iso_key);

      // 보너스 폴더수 체크
      if (state.sportsBetSlip.slip.find(x => x.match.ism_key === '보너스')) {
        if (
          state.sportsBetSlip.slip.filter(x => x.match.ism_key !== '보너스').length < state.sportsBetSlip.slip.find(x => x.match.ism_key === '보너스').odds.bonusInfo.isbf_folder
        ) {
          state.sportsBetSlip.slip = state.sportsBetSlip.slip.filter(x => x.match.ism_key !== '보너스');
        }
      }
    },
    calcSlipTotalOdds: function (state, payload = {}) {
      if (state.sportsBetSlip.slip.length > 0) {
        state.sportsBetSlip.totalOdds = 1;
      } else {
        state.sportsBetSlip.totalOdds = 0;
      }

      state.sportsBetSlip.slip.forEach(x => {
        if (x.betType === 0) {
          state.sportsBetSlip.totalOdds = parseFloat(state.sportsBetSlip.totalOdds) * parseFloat(x.odds.iso_away_odds);
        } else if (x.betType === 1) {
          state.sportsBetSlip.totalOdds = parseFloat(state.sportsBetSlip.totalOdds) * parseFloat(x.odds.iso_home_odds);
        } else if (x.betType === 2) {
          state.sportsBetSlip.totalOdds = parseFloat(state.sportsBetSlip.totalOdds) * parseFloat(x.odds.iso_draw_odds);
        }
      });
    },
    resetSlip: function (state, payload = {}) {
      state.sportsBetSlip = {
        amount: 0,
        totalOdds: 0,
        slip: [],
      };
    },
    setSportsCombine: function (state, payload = {}) {
      state.sportsCombineArr = payload;
    },
    setMatchData: function (state, payload = {}) {
      if (payload.action === 'append') {
        state[payload.state].push(...payload.data);
      } else if (payload.action === 'set') {
        state[payload.state] = payload.data;
      } else if (payload.action === 'clear') {
        state[payload.state] = [];
      }
    },
    setBalance: function (state, payload = {}) {
      state.balance.wallet = payload.data.wallet;
      state.balance.balance = payload.data.balance;
      state.balance.comp = payload.data.comp;
    },
    setInfo: function (state, payload = {}) {
      state.info = payload.data;
    },
    setCommunityCategories: function (state, payload = {}) {
      state.communityCategories = payload.data;
    },
    setSiteConfig: function (state, payload = {}) {
      state.siteConfig = payload;
    },
    setLocale: function (state, payload = {}) {
      state.locale = payload;
    },
    setDomainInfo: function (state, payload = {}) {
      state.domainInfo = payload;
    },
  },
  actions: {
    setCommunityCategories: function (context, payload) {
      context.commit('setCommunityCategories', payload);
    },
    selectBet: function (context, payload) {
      context.commit('selectBet', payload);
    },
    deleteBet: function (context, payload) {
      context.commit('deleteBet', payload);
    },
    calcSlipTotalOdds: function (context, payload) {
      context.commit('calcSlipTotalOdds', payload);
    },
    resetSlip: function (context, payload) {
      context.commit('resetSlip', payload);
    },
    setSportsCombine: function (context, payload) {
      context.commit('setSportsCombine', payload);
    },
    setMatchData: function (context, payload) {
      context.commit('setMatchData', payload);
    },
    getBalance: function (context) {
      instance.get('/web/my/balance', {}).then(res => {
        context.commit('setBalance', res);
      });
    },
    getInfo: function (context) {
      instance.get('/web/my/info', {}).then(res => {
        context.commit('setInfo', res);
      });
    },
    setSiteConfig: function (context, payload) {
      context.commit('setSiteConfig', payload);
    },
    setLocale: function (context, payload) {
      context.commit('setLocale', payload);
    },
    setDomainInfo: function (context, payload) {
      context.commit('setDomainInfo', payload);
    },
    logout: function (context, payload) {
      return new Promise(resolve => {
        setTimeout(function () {
          context.commit('logout', payload);
          resolve({});
        }, 100);
      });
    },
    register: function (context, payload) {
      return new Promise((resolve, reject) => {
        instance
          .post('/auth/user/register', payload)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    login: function (context, payload) {
      const params = {
        username: payload.username,
        password: payload.password,
      };
      return new Promise((resolve, reject) => {
        instance
          .post('/auth/login', params)
          .then(response => {
            const { data } = response;
            if (data.accessToken) {
              context.commit('login', {
                accessToken: data.accessToken,
                memberData: data,
              });
            }
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
  },
  modules: {},
  plugins: [createPersistedState()],
});
